var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgHeart = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 25.09,
      height: 21.699,
      viewBox: "0 0 25.09 21.699",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "_001-heart",
      "data-name": "001-heart",
      d: "M12.545,56.293a.734.734,0,0,1-.367-.1,43.894,43.894,0,0,1-6.033-4.341A24.887,24.887,0,0,1,1.96,47.369,9.459,9.459,0,0,1,0,41.988a7.768,7.768,0,0,1,1.981-5.2,6.5,6.5,0,0,1,4.835-2.192,6.71,6.71,0,0,1,5.728,3.4,6.71,6.71,0,0,1,5.728-3.4,6.532,6.532,0,0,1,4.648,1.978A7.658,7.658,0,0,1,25.09,42a9.643,9.643,0,0,1-2,5.372,25.209,25.209,0,0,1-4.179,4.483,44.046,44.046,0,0,1-6,4.341.735.735,0,0,1-.37.1Z",
      transform: "translate(0 -34.594)"
    })))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgHeart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Heart.9698f8fa.svg";
export { ForwardRef as ReactComponent };